import {useEffect} from 'react'
import {trackCartSkeletonLoading} from '../../../tracking/analytics'

const useCartSkeletonLoading = () => {
    const skeletonStartLoadingMark = 'cartSkeletonStartLoading'
    const skeletonMeasureMark = 'measuredSkeletonLoadingTime'

    useEffect(() => {
        return () => {
            clearPerformanceMarks()
        }
    }, [])

    const clearPerformanceMarks = () => {
        performance?.clearMarks?.(skeletonStartLoadingMark)
        performance?.clearMeasures?.(skeletonMeasureMark)
    }

    const skeletonShowing = () => {
        if (!performance?.getEntriesByName?.(skeletonStartLoadingMark)?.length) {
            performance?.mark?.(skeletonStartLoadingMark)
            performance?.clearMeasures?.(skeletonMeasureMark)
        }
    }

    const pageLoaded = () => {
        if (
            !performance?.getEntriesByName?.(skeletonMeasureMark)?.length &&
            performance?.getEntriesByName?.(skeletonStartLoadingMark)?.length
        ) {
            performance?.measure?.(skeletonMeasureMark, skeletonStartLoadingMark)
            trackCartSkeletonLoading(
                performance?.getEntriesByName?.(skeletonMeasureMark)?.[0]?.duration
            )
            clearPerformanceMarks()
        }
    }

    return {skeletonShowing, pageLoaded}
}

export default useCartSkeletonLoading
